import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { DialogPltKSConfirmation } from './DialogPltKSConfirmation'

export const BannerPltConfirmation = () => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)

  return (
    <>
      <Card
        className={
          '!flex-row p-5 gap-6 border space-between items-start !border-interactive-critical-default'
        }
      >
        <div className="flex gap-6">
          <Icon color="critical" fontSize="lg">
            warning
          </Icon>
          <div className="space-y-1">
            <Text variant="heading-lg">
              Penting! Pengelolaan Kinerja tertunda
            </Text>
            <Text color="subdued">
              Mohon segera konfirmasi data Anda sebagai Kepala Sekolah berstatus
              Plt. (Pelaksana Tugas) untuk melanjutkan Pengelolaan Kinerja
              satuan pendidikan Anda.
            </Text>
          </div>
        </div>
        <Button
          size="lg"
          className="ml-auto flex-shrink-0"
          onClick={() => setShowConfirmationDialog(true)}
        >
          Konfirmasi data
        </Button>
      </Card>

      <DialogPltKSConfirmation
        isOpen={showConfirmationDialog}
        onClose={() => setShowConfirmationDialog(false)}
      />
    </>
  )
}
